<template>
    <div class="Equity" v-if="init">
        <pull :pull="pull" :page="page" @getList="getList" v-if="dataList.length>0">
            <div class="compList" v-for="(obj, index) in dataList" :key="index">
                <div class="list_title van-ellipsis">{{obj.companyname}}</div>
                <div class="compMain">
                    <p>注册资本：<b>{{obj.regcapital}}</b></p>
                    <p>持股方式：<b>{{obj.holdingtype}}</b></p>
                    <p>股份来源：<b>{{obj.sharesource}}</b></p>
                    <p>生成时间：<b>{{obj.datetime}}</b></p>
                </div>
                <div class="compBtn">
                    <span class="red" @click="downReport(obj.fullfileurl,obj.isdownloadresult,obj.orderno)">下载报告</span>
                    <span class="line">|</span>
                    <span @click="seeReport(obj.orderno)">查看报告</span>
                </div>
            </div>
        </pull>
        <!--暂无数据-->
        <div class="noData"  v-if="!dataList.length">
            <img :src="require('@/common/images/gujingimgs/my/noData.png')"  alt="">
            <p>当前暂无数据</p>
        </div>
    </div>
</template>

<script>
    import {getAllSiListByUser} from 'api/gujingApi'
    import Pull from 'views/mobile/components/pull/pull'
    import {mapActions, mapGetters} from 'vuex'
    export default {
        name: 'Equity',
        data() {
            return {
                init: false,
                dataList: [],
                param: {},
                page: {
                    page: 1,
                    pageSize: 10,
                    pageCount: 0,
                    rowCount: 0
                },
                pull: {
                    isLoading: false,
                    loading: false,
                    error: false,
                    finished: false
                },
            }
        },
        mounted() {
            this.getList()
        },
        methods: {
            getList() {
                this.setLoading(true)
                getAllSiListByUser({
                    data: Object.assign({}, this.param, this.page),
                    success: data => {
                        this.init = true;
                        if (this.page.page === 1) {
                            this.pull.isLoading = false;
                            this.dataList = data.data.content
                        } else {
                            this.dataList = this.dataList.concat(data.data.content)
                        }
                        this.setLoading(false)
                        this.pull.loading = false
                        this.page.pageCount = data.data.pageinfo.pageCount;
                        this.page.rowCount = data.data.pageinfo.rowCount;
                        if (this.page.page >= this.page.pageCount) {
                            this.pull.finished = true
                        }else{
                            this.pull.finished = false
                        }
                    },
                    error: data => {
                        this.setLoading(false)
                        this.pull.error = true
                        this.pull.loading = false
                        this.$toast.fail(data.msg)
                    }
                })
            },
            // 下载/获取
            downReport(fullfileurl,isdownloadresult,orderno){
                if(isdownloadresult==0){
                    this.$router.push({name: 'MDownloadReport',query: {orderno: orderno}})
                }else{
                    window.open(fullfileurl)
                }
            },
            seeReport(orderno){
                this.$router.push({name: 'MLookReport',query: {orderno: orderno}})
            },
            ...mapActions(['setLoading', 'setRefresh'])
        },
        filters: {},
        watch: {},
        computed: {
            ...mapGetters(['refresh'])
        },
        components: {
            Pull
        }
    }
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    @import "~common/scss/variable";
    .Equity {
        .compList{
            height:auto;
            background:rgba(255,255,255,1);
            border-radius:0.10rem;
            margin: 0.2rem 0.32rem 0;
            .list_title{
                height: 1rem;
                line-height: 1rem;
                margin: 0 0.28rem;
                border-bottom: 0.01rem solid #eee;
                display: flex;
                justify-content: space-between;
                font-size: 0.32rem;
                color: #333;
                overflow: hidden;
                text-overflow:ellipsis;
                white-space: nowrap;
            }
            .compMain{
                margin: 0.28rem;
                p{
                    padding-bottom: 0.28rem;
                    font-size: 0.28rem;
                    color: #999;
                    b{
                        color: #666;
                    }
                }
                p:last-child{
                    padding-bottom: 0
                }
            }
            .compBtn{
                height: 0.8rem;
                line-height: 0.8rem;
                border-top: 0.01rem solid #eee;
                text-align: center;
                font-size: 0.28rem;
                color: #409EFF;
                display: flex;
                justify-content: space-evenly;
                .red{
                    color: #F56C6C;
                }
                .line{
                    color: #eee;
                }
            }
        }
        .noData{
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            img{
                width: 2.31rem;
                height: 1.83rem;
            }
            p{
                font-size: 0.28rem;
                color: #999;
                margin-top: 0.38rem;
                text-align: center;
            }
        }
    }
</style>